var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap pr"},[_c('div',{staticStyle:{"height":"310px"},attrs:{"id":"preview-chart"}}),(_vm.nodata)?_c('div',{staticClass:"pa dp-flex align-item-c justify-c",staticStyle:{"top":"0","left":"0","bottom":"0","right":"0","background-color":"#00000008"}},[_vm._v(" 暂无数据 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }